var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.0625C15.7794 30.0625 15.5596 29.9856 15.3829 29.8309C14.0188 28.6379 12.7215 27.532 11.5011 26.4919C4.61356 20.6225 0 16.7443 0 11.0946C0 5.87425 3.68981 1.9375 8.5 1.9375C12.2912 1.9375 14.7247 4.58613 16 6.97106C17.2753 4.58613 19.7088 1.9375 23.5 1.9375C28.3102 1.9375 32 5.87425 32 11.0946C32 16.7444 27.3864 20.6225 20.4989 26.4919C19.2785 27.532 17.9812 28.6379 16.6171 29.8309C16.4404 29.9856 16.2206 30.0625 16 30.0625Z",
    fill: "#FD3018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6171 29.8309C17.9812 28.6379 19.2785 27.532 20.4989 26.4919C27.3864 20.6225 32 16.7443 32 11.0946C32 5.87425 28.3102 1.9375 23.5 1.9375C19.7088 1.9375 17.2753 4.58613 16 6.97106V30.0625C16.2206 30.0625 16.4404 29.9856 16.6171 29.8309Z",
    fill: "#E61E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c6cd8fc3.svg";
export { ForwardRef as ReactComponent };